import tibBannerStore from './store'

export default class TibBannerModule {
  name = 'tibBanner'
  constructor({ store }) {
    store.registerModule(this.name, tibBannerStore)
  }
}
